export default {
  remote: 'simplify_hub_eap_onboard_mfe',
  name: 'eap-onboard',
  source: 'https://github.com/telus/eap-onboard-mfe',
  urlMapping: {
    localhost:
      'https://assets.wcpreview.telus.com/1164931304/eap-onboard-mfe/v1/mf2/mf-manifest.json',
    'simplify.developers.telus.digital':
      'https://assets.wcpreview.telus.com/1164931304/eap-onboard-mfe/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital':
      'https://assets.wcstage.telus.com/1164931304/eap-onboard-mfe/v1/mf2/mf-manifest.json',
    'simplify.telus.com':
      'https://assets.telus.com/1164931304/eap-onboard-mfe/v1/mf2/mf-manifest.json',
  },
};
